
import { Droplet, MapPin, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';

const HowItWorksSection = () => {
  return (
    <section className="section-padding bg-white text-autocare-blue">
      <div className="page-container">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-autocare-blue bg-autocare-blue/10 rounded-full mb-4">
            عملية سهلة
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">كيف يعمل أوتو كير</h2>
          <p className="text-autocare-blue/80 max-w-2xl mx-auto">احصل على خدمة سيارتك في ثلاث خطوات بسيطة، مما يوفر وقتك ويضمن أفضل جودة.</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="bg-autocare-blue/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
              <Droplet className="h-8 w-8 text-autocare-blue" />
            </div>
            <h3 className="text-xl font-semibold mb-3">اعثر على زيتك</h3>
            <p className="text-autocare-blue/80">
              أدخل تفاصيل مركبتك واحصل على توصيات زيوت مخصصة تتناسب مع متطلبات سيارتك.
            </p>
          </div>
          
          <div className="text-center">
            <div className="bg-autocare-blue/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
              <MapPin className="h-8 w-8 text-autocare-blue" />
            </div>
            <h3 className="text-xl font-semibold mb-3">اختر محل</h3>
            <p className="text-autocare-blue/80">
              تصفح مراكز الخدمة القريبة، قارن الأسعار، اقرأ التقييمات، واختر أفضل خيار لاحتياجاتك.
            </p>
          </div>
          
          <div className="text-center">
            <div className="bg-autocare-blue/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
              <Calendar className="h-8 w-8 text-autocare-blue" />
            </div>
            <h3 className="text-xl font-semibold mb-3">احجز الخدمة</h3>
            <p className="text-autocare-blue/80">
              جدول موعداً في الوقت المناسب لك، واحصل على تأكيد، وقم بتغيير زيتك بدون متاعب.
            </p>
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Link to="/oil-finder" className="btn-secondary">
            ابدأ الآن
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
